import React, { useState, useEffect } from "react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/solid";
import classes from "./searchInput.module.css";

export const SearchInput = ({ placeholder, value, onSearch, onClear }) => {
  const [text, setText] = useState(value || "");
  const [searched, setSearched] = useState(() => !!value); // <-- important

  useEffect(() => {
    setText(value || "");

    if (value) setSearched(true);   // keep X after remount/URL change
    else setSearched(false);
  }, [value]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (!text.trim()) return;

    setSearched(true);       // X appears immediately
    onSearch?.(text);
  };

  const handleClear = () => {
    setText("");
    setSearched(false);
    onClear?.();
  };

  return (
    <form onSubmit={handleSearch} className={classes.wrapper}>
      <input
        type="text"
        placeholder={placeholder}
        className={classes.input}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />

      {searched ? (
        <button type="button" className={classes.iconBtn} onClick={handleClear}>
          <XMarkIcon className={classes.icon} />
        </button>
      ) : (
        <button type="submit" className={classes.iconBtn}>
          <MagnifyingGlassIcon className={classes.icon} />
        </button>
      )}
    </form>
  );
};
